import { t } from "i18n-js";
import basicRequest from "../../../../core/redux/actions/request";

const PREFIX = "MANAGER_VENDOR_TAG";
const getState = (state) => state.manager.vendor.tag;

const {
    error,
    loading,
    success,
    reset,
    getPattern,
    secondaryError,
    secondaryLoading,
    secondarySuccess,
    isSecondaryLoading,
    actionPostPattern,
    actionPutPattern,
    isLoaded,
    isLoading,
    getError,
    getData,
} = basicRequest(PREFIX, getState);

export const updateTags = (vendorId, form) =>
    actionPostPattern("manager/vendors/v2/" + vendorId + "/tags", form, {
        message: "Updated",
        description: "The vendor was updated.",
    });

export const load = (id) => getPattern("manager/vendors/v2/" + id + "/tags", {}, null);

export { reset, isLoading, getError, getData, isLoaded, isSecondaryLoading };
